import { VXETable } from '../v-x-e-table';
import PanelComponent from './src/panel';
import menuHook from './src/hooks';
import { dynamicApp } from '../dynamics';
export var VxeModuleMenu = {
    Panel: PanelComponent,
    install: function (app) {
        VXETable.hooks.add('$tableMenu', menuHook);
        app.component(PanelComponent.name, PanelComponent);
    }
};
export var Menu = VxeModuleMenu;
dynamicApp.component(PanelComponent.name, PanelComponent);
export default VxeModuleMenu;
